// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { ContainerControl } from './ContainerControl';
import TerceraGroupButtonsTemplate from '@front/templates/TerceraGroupButtonsTemplate.html';
export class TerceraGroupButtons extends ContainerControl {
    constructor() {
        super();
    }
    onBtnClick(buttonInfo) {
        const buttonsInfo = this.get('buttonsInfo');
        for (let i = 0; i < buttonsInfo.length; i++) {
            buttonsInfo[i].isChecked = buttonsInfo[i].name === buttonInfo.name;
        }
        this.fire('groupBtnClick', this, buttonInfo);
        void this.update();
    }
}
export class TerceraButtonInfo {
    constructor(name, text, isChecked) {
        this.name = name;
        this.text = text;
        this.isChecked = isChecked;
    }
}
ContainerControl.extendWith(TerceraGroupButtons, {
    template: TerceraGroupButtonsTemplate,
    data: function () {
        return {
            buttonsInfo: []
        };
    }
});
